import { render, staticRenderFns } from "./features.vue?vue&type=template&id=3d0a8c05&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"
import style0 from "./features.vue?vue&type=style&index=0&id=3d0a8c05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0a8c05",
  null
  
)

export default component.exports